import { combineReducers, configureStore } from '@reduxjs/toolkit'
import type { AnyAction, EnhancedStore, ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'

import channelConnectionsReducer from './channelConnectionsReducer'
import modalsReducer from './modalsReducer'
import type { OrchestratorRootState } from '../../../common/events/types'

export const storeReducers = combineReducers({
  channelConnections: channelConnectionsReducer,
  modals: modalsReducer,
})
const store = configureStore({
  reducer: storeReducers,
  // RTK's dev invariant checks console.warn past their 32ms threshold under CI
  // contention, failing jest-fail-on-console; off in test, kept for dev serve.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(
      process.env.NODE_ENV === 'test'
        ? { immutableCheck: false, serializableCheck: false }
        : undefined,
    ),
}) as EnhancedStore<OrchestratorRootState>

export type RootState = ReturnType<typeof store.getState>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = (): ThunkDispatch<
  RootState,
  undefined,
  AnyAction
> => useDispatch<AppDispatch>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
